import { useEffect, useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { EditButton } from "ui-components/IconButton";
import { Success, Error, MessageDialog } from "ui-components/Alert";
import BasicTabs from "ui-components/BasicTabs";
import { useCustomerValue } from "providers/CustomerContext";
import { getASNList } from "services/data.inbound.service";
import { getASNStatusCount } from "services/data.inbound.service";
import { deleteASN } from "services/data.inbound.service";
import ASNLog from "./components/ASNLog";
import { CancelButton } from "ui-components/IconButton";
import { TableCard } from "ui-components/Layout";
import { statusObj } from "layouts/views/common/enum";
import { useTeamValue } from "providers/TeamContext";
function ASNList() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode: custCode } = useCustomerValue();
  const enabled = custCode !== null;
  const navigate = useNavigate();
  const location = useLocation();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("Open");
  const [tabs, setTabs] = useState([{label:"Open",count:0},{label:"Cancelled",count:0},{label:"Received",count:0}]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Advance Shipment Notice"]) && permissions["Advance Shipment Notice"].findIndex(b => b==="new") !== -1);
  const editPermission = allowAll || (Boolean(permissions["Advance Shipment Notice"]) && permissions["Advance Shipment Notice"].findIndex(b => b==="edit") !== -1);
  const deactivatePermission = allowAll || (Boolean(permissions["Advance Shipment Notice"]) && permissions["Advance Shipment Notice"].findIndex(b => b==="deactivate") !== -1);

  useEffect(() => {
    if (location.state) {
      setAlert(<Success content={location.state} onChange={setAlert} />);
    }
  }, []);

  useQuery({
    queryKey: ["asn-list", { custCode, status }],
    queryFn: () => getASNList({ custCode, status: statusObj[status] }),
    enabled,
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  useQuery({
    queryKey: ["asn-list", "status", { custCode }],
    queryFn: () => getASNStatusCount({ custCode }),
    enabled,
    onSuccess: (data) => {
      setTabs(data.data.data);
    },
    onError,
  });

  const delMutation = useMutation(deleteASN, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["asn-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const onEdit = (req) => {
    navigate("/inbound/asn/edit", {
      state: req,
    });
  };

  const onDelete = (req) => {
    setDialog(
      <MessageDialog
        title={`Delete ASN Number ${req.asnNumber}`}
        onClose={() => setDialog(null)}
        onOk={() => {
          delMutation.mutate(req);
          setDialog(null);
        }}
      />
    );
  };

  const [logRequest, setLogRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const logProp = { open, setOpen, logRequest, setLogRequest };

  const columns = [
    {
      header: "ASN Number",
      accessorKey: "asnNumber",
      cell: ({ row }) => {
        const { asnNumber, customerCode } = row.original;
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setLogRequest({ asnNumber, customerCode });
            }}
          >
            {asnNumber}
          </span>
        );
      },
    },
    { header: "Date Expected", accessorKey: "dateExpected" },
    { header: "PO Number", accessorKey: "poNumber" },
    { header: "Vendor Code", accessorKey: "vendorCode" },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { asnNumber, customerCode } = row.original;
        return status === "Open" ? (
          <>
            <EditButton
              title="edit asn"
              disabled={!editPermission}
              onClick={() => {
                onEdit({ asnNumber, customerCode });
              }}
            />
            <CancelButton
              title="cancel asn"
              disabled={!deactivatePermission}
              onClick={() => {
                onDelete({ asnNumber, customerCode });
              }}
            />
          </>
        ) : (
          <></>
        );
      },
    },
  ];
  const rows = data;
  return (
    <ListLayout>
      <ASNLog {...logProp} />
       
      {dialog}
      <MDBox my={3}>
      {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />
      </MDBox>
      <TableCard>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={() => navigate("/inbound/asn/add")}>
            <Icon>add</Icon>&nbsp;asn
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={rows} />
      </TableCard>
    </ListLayout>
  );
}

export default ASNList;
